import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CouponRequest, Plan } from '../models/activation-link.model';
import { Observable } from 'rxjs';
import { OnboardingLink, PlanAddon } from 'voxloud-types/dist/models';

@Injectable()
export class ActivationLinkService {

  constructor(private http: HttpClient) {}

  getAllPlans() {
    return this.http.get(`${environment.apiEndpoint}/api/v1/subscriptions/plans`);
  }

  getPlanById(planId: string): Observable<Plan> {
    return this.http.get<Plan>(`${environment.apiEndpoint}/api/v1/subscriptions/plans/${planId}`);
  }

  getChargebeeAccountByCountry(countryCode: string) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/chargebee/by-country/${countryCode}`);
  }

  createNewCoupon(payload: CouponRequest) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/coupons`, payload)
  }

  getAddonsByPlan(planId: string): Observable<PlanAddon[]> {
    return this.http.get<PlanAddon[]>(`${environment.apiEndpoint}/api/v1/subscriptions/addons/by-plan/${planId}`);
  }

  saveOnboardingData(user: string, expires_at: string, data: string): Observable<OnboardingLink> {
    return this.http.post<OnboardingLink>(`${environment.apiEndpoint}/api/v1/onboardings/links`,  {
      user,
      expires_at,
      data
    });
  }
}